import React from 'react'

import styles from './styles.module.scss'

const ENV_LABEL: string = import.meta.env.REACT_APP_ENV_RIBBON ?? ''

export const EnvironmentRibbon = (): React.JSX.Element | null => {
  if (!ENV_LABEL) return null

  return (
    <div className={styles.ribbon} data-testid="environment-ribbon">
      {ENV_LABEL}
    </div>
  )
}
